import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { IApiInvestigationMetricsDeterminationConnection, IApiInvestigationMetricsFilter } from '../../../../types/types';
import { IGqlBaseOptions } from '../../../../interfaces';
import { investigationMetricsDeterminationConnection } from './investigation-metrics-determination.operations';
import { connectionQuery } from '../../../../helpers.class';

@Injectable()
export class GqlInvestigationMetricsDeterminationService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsDeterminationConnection> {
    return this.apollo.query(connectionQuery(investigationMetricsDeterminationConnection, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
